<template>
<div>
  <b-card :title="$t('message.Guideline.section5')" class="mb-2">
    <b-row class="mb-5">
      <b-col sm="12">
        <template v-if="guidelineBudgets.length > 0">
          <b-table striped hover :sort-by="'start'" id="budgetsTable" ref="budgetsTable" :items="guidelineBudgets" :fields="budgetFields">
            <template slot="table-colgroup">
              <col width="110px">
              <col>
              <col width="150px">
            </template>

            <template slot="start" slot-scope="data">
              {{ moment(data.item.start).format('DD-MM-YYYY') }}
            </template>
            <template slot="type" slot-scope="data">
              <b-badge
                class="mt-1"
                variant="primary"
                v-if="data.item.type == 'meeting'"
                >{{ $t('message.Guideline.Milestones.meeting') }}</b-badge>

              <b-badge
                class="mt-1"
                variant="secondary"
                v-if="data.item.type == 'meta'"
                v-html="$t('message.Guideline.Milestones.metaHtml')">
                </b-badge>
              <b-badge
                class="mt-1"
                variant="success"
                v-if="data.item.type == 'medical'">
                {{ $t("message.Guideline.Milestones.medical") }}
              </b-badge>
              <b-badge
                class="mt-1"
                variant="danger"
                v-if="data.item.type == 'publication'">
                {{ $t("message.Guideline.Milestones.publication") }}</b-badge>
            </template>
            <template slot="budget" slot-scope="data">
              {{ data.item.budget }} &euro;
            </template>
            
            <template slot="actions" slot-scope="data">
              <b-row>
                  <b-col>
                    <a @click.prevent="editMilestone(data.item.id)" class="i-con-h-a">
                        <span class="nav-icon">
                          <i class="i-con i-con-edit"></i>
                        </span>
                    </a>
                  </b-col>
                  <b-col>
                    <a @click.prevent="deleteMilestone(data.item.id)" class="i-con-h-a">
                        <span class="nav-icon">
                          <i class="i-con i-con-trash"><i></i></i>
                        </span>
                    </a>
                  </b-col>
              </b-row>
            </template>
          </b-table>
  
          <template v-if="isGpc | isSuperUser">
            <b-button variant="success" @click="updateBudget" class="float-right" v-if="saveChanges">{{ $t('message.apply') }}</b-button>
            <b-dropdown variant="primary" class="float-right mr-2" :text="$t('message.add')">
              <b-dropdown-item @click="showMilestoneModal('meeting')" >{{ $t('message.Guideline.Milestones.meeting') }}</b-dropdown-item>
              <b-dropdown-item @click="showMilestoneModal('medical')">{{ $t("message.Guideline.Milestones.medical") }}</b-dropdown-item>
              <b-dropdown-item @click="showMilestoneModal('meta')" >{{ $t('message.Guideline.Milestones.metaButtonShortLabel') }}</b-dropdown-item>
              <b-dropdown-item v-if="publicationFeeCounter == 0" @click="showMilestoneModal('publication')" >{{ $t("message.Guideline.Milestones.publication") }}</b-dropdown-item>
            </b-dropdown>
          </template>
        </template>
        <template v-else> 
          {{ $t("message.Guideline.Milestones.noBudget") }}

          <template v-if="isGpc | isSuperUser">
            <b-button variant="success" @click="updateBudget" class="float-right" v-if="saveChanges">{{ $t('message.apply') }}</b-button>
            <b-dropdown variant="primary" class="float-right mr-2" :text="$t('message.add')">
              <b-dropdown-item @click="showMilestoneModal('meeting')" >{{ $t('message.Guideline.Milestones.meeting') }}</b-dropdown-item>
              <b-dropdown-item @click="showMilestoneModal('medical')">{{ $t("message.Guideline.Milestones.medical") }}</b-dropdown-item>
              <b-dropdown-item @click="showMilestoneModal('meta')" >{{ $t('message.Guideline.Milestones.metaButtonShortLabel') }}</b-dropdown-item>
              <b-dropdown-item v-if="publicationFeeCounter == 0" @click="showMilestoneModal('publication')" >{{ $t("message.Guideline.Milestones.publication") }}</b-dropdown-item>
            </b-dropdown>
          </template>
        </template>
      </b-col>
    </b-row>
  </b-card>

  <!-- Modals Component -->
  <b-modal
    id="milestoneModal"
    ref="milestoneModal"
    hide-footer
    :title="milestoneModal.title">

    <b-row class="mb-3">
      <b-col sm="5">
        {{ $t('message.Guideline.Milestones.title') }} <var class="text-danger">*</var>
      </b-col>
      <b-col sm="7">
        <b-form-input
          v-model="milestone.title"
          type="text"
          :placeholder="$t('message.Guideline.Milestones.titlePlaceholder')"
          v-validate="'required'"
          data-vv-name="milestone.title"
          data-vv-scope="milestone"
          :state="errors.has('milestone.title')?false:null"
          ></b-form-input>
      </b-col>
    </b-row>

    <b-row class="mb-3">
      <b-col sm="5">
        {{ $t('message.Guideline.Milestones.budget') }} <var class="text-danger">*</var>
      </b-col>
      <b-col sm="7">
        <b-form-input
          v-model="milestone.budget"
          type="text"
          :placeholder="$t('message.Guideline.Milestones.budget')"
          v-validate="'required|decimal:2'"
          data-vv-name="milestone.budget"
          data-vv-scope="milestone"
          :state="errors.has('milestone.budget')?false:null"
          ></b-form-input>
        <div class="invalid-feedback">{{ $t('message.Guideline.Milestones.budgetInvalid') }}</div>
      </b-col>
    </b-row>

    <b-row class="mb-3">
      <b-col sm="7">
        {{ $t('message.Guideline.Milestones.chooseStartDate') }} <var class="text-danger">*</var>
      </b-col>
      <b-col sm="5">
        <datepicker
          class="w-100"
          :value="milestone.start"
          v-model="milestone.start"
          format="dd-MM-yyyy"
          input-class="form-control">
          </datepicker>

        <input
          type="hidden"
          v-model="milestone.start"
          v-validate="'required'"
          data-vv-name="milestone.start"
          data-vv-scope="milestone"
          />
        <p v-show="errors.has('milestone.start')" class="text-danger">{{ $t("message.chooseProperDate") }}</p>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col>
        <var class="text-danger">*</var>{{ $t("message.fieldRequired") }}
      </b-col>
    </b-row>

    <b-btn class="mt-3" variant="success" block @click="addMilestone">{{  milestoneModal.add?$t("message.add"):$t("message.update") }}</b-btn>
  </b-modal>
</div>
</template>

<script>
import { Milestone } from '@/lib/guideline.js';
import Api from '@/services/Api';

export default {
  name: 'guideline-budgets',
  props: ['guideline'],

  data() {
    return {
      milestone: new Milestone,
      milestoneModal: {
        title: ''
      },

      saveChanges: false,
    }
  },

  computed: {
    guidelineBudgets() {
      return this.guideline.budget;
    },

    publicationFeeCounter() {
      return this.guideline.budget.filter((arg) => { return arg.type == 'publication' }).length;
    },

    budgetFields() {
      let fields = [
        {
          key: 'start',
          label: this.$t('message.Guideline.Milestones.dueDate'),
        },
        {
          key: 'title',
        },
        {
          key: 'budget',
        },
        {
          key: 'type',
          label: this.$t('message.Guideline.Milestones.type'),
        },
        
      ]

      if (this.isGpc | this.isSuperUser) {
        fields.push({
          key: 'actions',
          label: 'Actions',
        });
      }

      return fields
    }
  },

  methods: {
    updateBudget() {
      if (this.isGpc | this.isSuperUser) {
        Api().post('/guideline-budgets/' + this.guideline.id, {
            budgets: this.guideline.budget
          })
        .then((response) => {
          this.$emit('refresh-guideline', response.data.data)
          this.saveChanges = false;
          this.$swal({
            title: 'Success',
            text: this.$t("message.Guideline.Milestones.budgetUpdated"),
            type: 'success',
            confirmButtonText: 'OK'
          });
        })
        .catch((error) => {
          this.handleUnauth(error.response.status);
          this.handleForbidden(error.response.status);
          this.handleUnprocessable(error.response);
        });
      }
    },

    editMilestone(id) {
      if (this.isGpc) {
        this.milestone = this.guideline.budget.filter( elem => { return elem.id == id } ).pop();
        this.milestoneModal.add = false;
        this.milestoneModal.title = this.$t('message.Guideline.Milestones.' + this.milestone.type);
        this.$refs.milestoneModal.show();
      }
    },

    showMilestoneModal(type) {
      this.$validator.reset({scope: 'milestone'});
      this.milestone = new Milestone(type);
      this.milestoneModal.title = this.$t('message.Guideline.Milestones.' + type);
      this.milestoneModal.add = true;
      this.$refs.milestoneModal.show();
    },

    addMilestone() {
      this.$validator.validateAll('milestone').then(result => {
        if (result) {
          if (this.guideline.budget.filter( elem => { return elem.id == this.milestone.id }).length == 0) {
            this.guideline.budget.push(this.milestone);
          }

          this.$refs.milestoneModal.hide();
          this.milestone = new Milestone;
          this.$validator.reset({scope: 'milestone'});

          this.updateBudget();
        } else {
          this.$swal({
            title: 'Error!',
            text: this.$t("message.Guideline.fillRequiredFields"),
            type: 'error',
            confirmButtonText: 'OK'
          });
        }
      });
    },

    deleteMilestone(id) {
      let elem = this.guideline.budget.filter( elem => { return elem.id == id });

      if (elem.length > 0) {
        for (var x in elem) {
          if (elem[x].delete != true) {
            elem[x].delete = true;
            elem[x]._rowVariant = 'danger';

            this.$swal({
              toast: true,
              position: 'bottom-end',
              title: this.$t("message.warning"),
              text: this.$t("message.markedToDel"),
              type: 'warning',
              timer: 3000,
              showConfirmButton: false,
            });
          } else {
            elem[x].delete = false;
            elem[x]._rowVariant = null;
          }
        }
      }

      this.saveChanges = this.guideline.budget.filter( elem => { return elem.delete == true }).length > 0;
    },
  },
  mounted() {}
}
</script>